<app-complex-modal-template
    [canConfirm]="createEditDataModalDataForm.valid"
    [stepNumber]="1"
    [title]="data.title | transloco"
    (onClickEvent)="onClickEvent($event)">
    <form [formGroup]="createEditDataModalDataForm">
        <div class="flex flex-row items-start w-full mt-6 mb-6">
            <div class="flex flex-col items-start w-80">
                <mat-label>{{ 'name' | transloco }}</mat-label>
                <mat-form-field
                    appearance="outline"
                    class="w-11/12"
                    floatLabel="always"
                    subscriptSizing="dynamic">
                    <div class="flex flex-row">
                        <input
                            #nameInput
                            class="!h-6"
                            matInput
                            type="text"
                            [formControlName]="'name'"
                            [placeholder]="'enterName' | transloco" />

                        @if (createEditDataModalDataForm.controls.name.dirty) {
                            <fa-icon
                                class="cursor-pointer hover:text-secondary text-on-surface"
                                size="lg"
                                [fixedWidth]="true"
                                [icon]="['fas', 'xmark']"
                                (click)="createEditDataModalDataForm.controls.name.reset()" />
                        }
                    </div>
                </mat-form-field>
                @if (createEditDataModalDataForm.controls.name.errors?.['required']) {
                    <mat-error
                        >{{
                            formService.getErrorMessage({
                                key: 'required',
                                value: createEditDataModalDataForm.controls.name.errors?.['required'],
                            })
                        }}
                    </mat-error>
                } @else {
                    @for (error of createEditDataModalDataForm.controls.name.errors | keyvalue; track error) {
                        <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                    }
                }
            </div>
            @if (!data.isEditMode) {
                <div class="flex flex-col w-80">
                    <app-select
                        [isMultiSelect]="false"
                        [label]="'standard' | transloco"
                        [placeholder]="'selectStandard'"
                        [(options)]="standardOptions"
                        (optionSelected)="selectStandard($event)" />
                </div>
            }
        </div>
    </form>
</app-complex-modal-template>
